import { render, staticRenderFns } from "./FlexibleOptimizationWidget.vue?vue&type=template&id=36b39149&scoped=true&"
import script from "./FlexibleOptimizationWidget.vue?vue&type=script&lang=js&"
export * from "./FlexibleOptimizationWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b39149",
  null
  
)

export default component.exports